import type { Plugin } from 'vue';
import { TextHelpers } from '../utils/textHelpers';
import type { IInternationalText } from '@license-manager/types';

declare module 'vue' {
  interface ComponentCustomProperties {
    $getLocalizedText(item: IInternationalText, language: string, fallbackLanguage?: string): string;
  }
}

export const TextHelpersPlugin: Plugin = {
  install(app) {
    app.config.globalProperties.$getLocalizedText = TextHelpers.getLocalizedText;
  }
};

export default TextHelpersPlugin;
